<template>
  <div>
    <div class="row q-mb-lg">
      <div class="col-1" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="this.$store.state.stringsStore.language === 'nl' ? 'Terug' : 'Back to'"
          @click="$router.push(`/defaultcart/${$route.params.id}`)"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6" style="justify-content: flex-start">
        <div class="q-ml-md" style="flex-grow: 1">
          <q-input
            color="grey-5"
            v-model="searchTerm"
            @input="applyFilters"
            :placeholder="getString('module.defaultcart.list.filter.label')"
          />
        </div>
      </div>
    </div>
    <table-overview
      :endpoint="`defaultcart/${$route.params.id}/usage`"
      :responseFormat="'web_orders'"
      :columns="columns"
      permission="defaultcarts"
      module="defaultcart"
      :row-click-disabled="true"
      :selectable="false"
    >
    </table-overview>
  </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  mixins: [filtersMixin],
  components: {
    TableOverview,
  },
  data() {
    return {
      isLoading: false,
      columns: [
        {
          name: 'account_name',
          title: this.$store.state.stringsStore.language === 'nl' ? 'Klant' : 'Client',
          sortField: 'account_name',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: 'contact_person',
          title:
            this.$store.state.stringsStore.language === 'nl' ? 'Contactpersoon' : 'Contact person',
          sortField: 'contact_person',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: 'order_number',
          title: this.$store.state.stringsStore.language === 'nl' ? 'Order nummer' : 'Order number',
          sortField: 'order_number',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m text-ellipsis',
        },
        {
          name: 'created_at',
          title: this.$store.state.stringsStore.language === 'nl' ? 'Datum' : 'Date',
          sortField: 'created_at',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
          callback: 'tableFormatTime',
        },
      ],
      filters: {
        name: '',
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  methods: {
    getString,
  },
};
</script>
